import type { FC, PropsWithChildren } from 'react';
import { lazy, Suspense } from 'react';

import Skeleton from './skeleton';

const Typography = lazy(() => import('@mui/material/Typography'));

// TODO: refactor types

interface IProps {
  [x: string]: unknown;
  height?: string | number;
  width?: string | number;
  className?: string;
}

const Preloader: FC<
  PropsWithChildren<{
    width?: string | number;
    height?: string | number;
    className?: string;
  }>
> = ({ width, height, className }) => {
  return <Skeleton width={width} height={height} variant="text" className={className} />;
};

const AtpTypography: FC<PropsWithChildren<IProps>> = ({ height, width, className, ...rest }) => {
  return (
    <Suspense fallback={<Preloader height={height} width={width} className={className} />}>
      <Typography {...rest} className={className} />
    </Suspense>
  );
};

export default AtpTypography;
